import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=317137d4&scoped=true"
import script from "./EmailSettings.vue?vue&type=script&lang=js"
export * from "./EmailSettings.vue?vue&type=script&lang=js"
import style0 from "./EmailSettings.vue?vue&type=style&index=0&id=317137d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317137d4",
  null
  
)

export default component.exports